import { render, staticRenderFns } from "./UserProfileSidebar.vue?vue&type=template&id=05d007ae"
import script from "./UserProfileSidebar.vue?vue&type=script&lang=js"
export * from "./UserProfileSidebar.vue?vue&type=script&lang=js"
import style0 from "./UserProfileSidebar.vue?vue&type=style&index=0&id=05d007ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports